const $ = window.jQuery || window.$;

$('.js-modal-close').on('click', function () {
    $('.js-modal').addClass('hidden')
})
